import { BaseApi } from './base.api.js';
import { ApiError } from '../errors/api-error.js';

export class SubjectPersonGroupApi extends BaseApi {
    constructor(client) {
        super(client, '/subject-person-group');
    }

    async getDropdown() {
        try {
            const response = await this.client.get(`${this.basePath}/dropdown/params`);
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }
}
